export enum EConsumptionValueComparison {
  HIGH = "HIGH",
  LOW = "LOW",
  EQUAL = "EQUAL",
  NOT_MEASURABLE = "NOT_MEASURABLE",
}
